import React, { useEffect, useRef, useState } from 'react';

export interface IInfiniteScroll {
    children?: React.ReactNode;
    pageSize: number;
    page: number;
    fetchFunc: (page: number) => Promise<void>;
    totalPackage: number;
    currentPackages: number;
    handleSetPage: React.Dispatch<React.SetStateAction<number>>;
}

export const InfiniteScroll: React.FC<IInfiniteScroll> = ({
    children,
    pageSize = 5,
    page,
    fetchFunc,
    totalPackage,
    currentPackages,
    handleSetPage,
}: IInfiniteScroll) => {
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async (page: number) => {
        setIsLoading(true);

        await fetchFunc(page);

        setIsLoading(false);
    };

    const observerTarget = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && page * pageSize < totalPackage && !isLoading) {
                    handleSetPage((prevPage) => {
                        const nextPage = prevPage + 1;
                        fetchData(nextPage);
                        return nextPage;
                    });
                }
            },
            { threshold: 1 },
        );
        if (observerTarget.current) {
            observer.observe(observerTarget.current);
        }
        return () => {
            if (observerTarget.current) {
                observer.unobserve(observerTarget.current);
            }
        };
    }, [observerTarget, page, currentPackages, totalPackage, isLoading, pageSize]);

    return (
        <>
            {children}
            {currentPackages > 0 && !isLoading ? <div ref={observerTarget}></div> : null}
        </>
    );
};
